import OrderShippingDetails from '@vue-storefront/core/modules/cart/types/OrderShippingDetails'
import PaymentMethod from '@vue-storefront/core/modules/cart/types/PaymentMethod'
import ShippingMethod from '@vue-storefront/core/modules/cart/types/ShippingMethod'
import CheckoutData from '@vue-storefront/core/modules/cart/types/CheckoutData'
import { currentStoreView } from '@vue-storefront/core/lib/multistore'

const getDefaultShippingMethod = (shippingMethods: ShippingMethod[] = []): ShippingMethod => {
  const onlineShippingMethods = shippingMethods.filter(shippingMethod => !shippingMethod.offline)
  if (!onlineShippingMethods.length) return

  return onlineShippingMethods.find(shippingMethod => !!shippingMethod.default_address) || onlineShippingMethods[0]
}

const getDefaultPaymentMethod = (paymentMethods: PaymentMethod[] = []): PaymentMethod => {
  if (!paymentMethods || !paymentMethods.length) return

  return paymentMethods.find(item => item.default) || paymentMethods[0]
}

const createOrderData = ({
  shippingDetails,
  returnShippingDetails,
  shippingMethods,
  paymentMethods,
  paymentDetails,
  hasTwoDeliveryAdresses,
  taxCountry = currentStoreView().tax.defaultCountry
}: CheckoutData): OrderShippingDetails => {
  const country = shippingDetails.country ? shippingDetails.country : taxCountry
  const shipping = getDefaultShippingMethod(shippingMethods)
  const payment = getDefaultPaymentMethod(paymentMethods)

  return {
    country,
    shippingAddress: {
      firstname: shippingDetails.firstName,
      lastname: shippingDetails.lastName,
      city: shippingDetails.city,
      postcode: shippingDetails.zipCode,
      street: [shippingDetails.streetAddress]
    },
    returnShippingAddress: returnShippingDetails ? {
      firstname: returnShippingDetails.firstName,
      lastname: returnShippingDetails.lastName,
      city: returnShippingDetails.city,
      postcode: returnShippingDetails.zipCode,
      street: [returnShippingDetails.streetAddress]
    } : {},
    billingAddress: {
      firstname: paymentDetails.firstName,
      lastname: paymentDetails.lastName,
      city: paymentDetails.city,
      postcode: paymentDetails.zipCode,
      street: [paymentDetails.streetAddress],
      countryId: paymentDetails.country
    },
    // this should contain the id from last transaction saved in vuex
    returnShippingMethodId: returnShippingDetails.shippingMethod ? returnShippingDetails.shippingMethod
      : shipping?.method_id ? shipping.method_id : null,
    // this should contain the code from last transaction saved in cache
    shippingMethodId: shippingDetails.shippingMethod ? shippingDetails.shippingMethod
      : shipping?.method_id ? shipping.method_id : null,
    carrier_code: shipping && shipping.carrier_code ? shipping.carrier_code : null,
    payment_method: payment && payment.code ? payment.code : null,
    hasTwoDeliveryAdresses: hasTwoDeliveryAdresses
  }
}

export default createOrderData
